<template>
  <div id="PainterList">
    <div id="container">
      <el-card id="list">
        <!--操作按钮-->
        <div class="patientList-operate" >
          <button id="danger" @click="deleteP">{{$t('Delete')}}</button>
          <el-button  size="small" @click="findPatient">{{$t('findP')}}</el-button>
          <el-button  size="small" @click="NewPatient">{{$t('newP')}}</el-button>
          <!--Filter提示框-->
          <el-popover ref="popover1" placement="bottom-start" width="300" trigger="hover" :disabled="tooltipVisible">
            <div class="patientList-label-tooltip">
              <div class="patientList-title"><span >{{$t('Filter')}}</span></div>
              <hr class="patientList-small2-hr">
              <div class="label-group">
                <div class="filter-label" v-show="lab2" :class="{'choose1':lab2,'de6':isDe||isIt,'po4':isPo,'fr2':isFr}"><span :class="{'ZH3':styleChange}">{{$t('Female')}}</span><img src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab3" :class="{'choose1':lab3,'es3':isEs,'de6':isDe||isIt,'po4':isPo}"><span :class="{'ZH3':styleChange}">{{$t('Male')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab17" :class="{'choose4':lab17,'de17':isDe,'po17':isPo||isDu}"><span>{{$t('genUn')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab18" :class="{'choose4':lab18,'po19':isPo||isDu}"><span>{{$t('ageUn')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab6" :class="{'choose1':lab6}"><span>< 18</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab7" :class="{'choose1':lab7}"><span>18-40</span><img src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab8" :class="{'choose1':lab8}"><span>40-60</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab9" :class="{'choose1':lab9}"><span>> 60</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab19" :class="{'choose4':lab19,'de18':isDe||isFr,'it18':isIt,'es18':isEs,'po18':isPo||isDu,'sw2':isSw}"><span>{{$t('disUn')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab16"  :class="{'choose1':lab16}"><span>{{$t('Other')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab11"  :class="{'choose1':lab11,'cz2':isCz}"><span>{{$t('Type 1')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab12"  :class="{'choose1':lab12,'cz2':isCz}"><span>{{$t('Type 2')}}</span><img  src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab13" :class="{'choose2':lab13,'de2':isDe,'it6':isIt,'du4':isDu,'fr1':isFr,'cz3':isCz}"><span>{{$t('Gestational')}}</span><img src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab14" :class="{'choose2':lab14,'po5':isPo}"><span>{{$t('Prediabetes')}}</span><img src="../assets/cancel_black.png"></div>
                <div class="filter-label" v-show="lab15"  :class="{'choose3':lab15, 'ZH2':styleChange}"><span>{{$t('LADA')}}</span><img  src="../assets/cancel_black.png"></div>
              </div>
            </div>
          </el-popover>
          <el-button id="filter" size="small"  @click="dialogFormVisible = true" v-popover:popover1 >{{$t('Filter')}}</el-button>
          <p class="back-btn" @click="backToMenu()" v-show="hcpGroupMenu"><a href="javascript:void(0);">{{$t('t0805_Back')}}</a></p>
          <div class="patientList-search" :class="{'patientList-in':searchPatient}">
             <input v-model="keywords" @focus="check(0)" @blur="check(1)" @keyup.13="check(1)">
             <img src="../assets/search.png" :class="{'patientList-in1':searchPatient}">
          </div>
        </div>
         <!--表格-->
        <div class="patient-table">
          <table id="patientList">
            <tr class="header">
              <td class="checkbox">
                <input type="checkbox" class="checkbox22" id="checkbox1" v-model="checked">
                <!-- <label @click="chooseAll" for="checkbox1" ></label> -->
              </td>
              <td>{{$t('Name')}}</td> <td>{{$t('Gender')}}</td> <td>{{$t('Age')}}</td><td>{{$t('Type')}}</td>
              <td>{{$t('Duration')}}</td> <td>{{$t('Connections')}}</td> <td>{{$t('UploadTime')}}</td>
            </tr>
            <tr v-if="!displayTab" v-for="(item,index) in currentPageData" :key="index" :data='users' :class="(index%2===0) ? '':'even'">
              <td class="checkbox">
                <input type="checkbox" class="checkbox22" v-model="checkList" :value="item.uid" autocomplate="off">
              </td>
              <td class="name" :id='index' @click="goDetail">
                <img class="portrait" :src="imgSrc" :onload="imgload(item.uid)" ref="imgs">
                <p :class="{'filterResult':filFlag2}">{{item.name}}</p>
              </td>
              <td class="gender">{{item.gender}}</td> <td class="small">{{item.age}}</td>
              <td class="small">{{item.diabetes_type}}</td>
              <td class="diabetes-date">{{item.diabetes_diagnosis_date}}</td> <td>{{item.created_by}}</td><td>{{item.upload_time}}</td>
            </tr>
          </table>
        </div>
         <el-table v-if="displayTab"
          v-loading="true"
          empty-text="--"
          :element-loading-text="$t('Loading')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"></el-table>
        <!--分页-->
        <div class="patientList-block">
            <img src="../assets/arrow_right.png" :class="{'click1': currentPage == 1}" @click="prevPage">
            <span> <input v-model="currentPage" @keyup.13="go" @blur='go'> of &nbsp;&nbsp;{{totalPage}}</span>
            <img src="../assets/arrow_left.png" :class="{'click1': currentPage == totalPage}" @click="nextPage">
        </div>
      </el-card>
      <div class="Hcp-footer">
        <span>
<!--          <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
          <a :href="contactURL">{{ $t('contact us') }} </a>
              <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
              <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

          {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
        </span>
      </div>
    </div>
    <!--Filter对话框-->
    <el-dialog  :visible.sync="dialogFormVisible" :size=dialogSize id="dialog-form" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('Filter')}}</span>
        <img src="../assets/cancel.png" @click="cancelFilter">
      </div>
      <div slot class="dialog-body">
        <hr class="patientList-small-hr">
        <div class="lab-group1">
          <label  :class="{'de3':isDe||isCz}" >{{$t('Gender')}}</label>
          <div class="patientList-line" :class="{'de4':isDe}" >
            <div class="label1" @click="choose1" :class="{'choose':lab1,'ZH1':styleChange,'es2':isEs||isIt||isFr,'de5':isDe,'po2':isPo,'du2':isDu, 'pl2':isPl}">
              <span :class="{'ZH':styleChange||isCz}">{{$t('All')}}</span>
              <img v-show="lab1" src="../assets/cancel_red.png">
            </div>
          </div>
          <div class="filter-label long-lab" :class="{'choose2':lab17 ,'es1':isEs,'de1':isDe,'po3':isPo,'du3':isDu,'fr1':isFr,'sw1':isSw, 'pl3':isPl}"  @click="choose17()">
            <span :class="{'ZH3':styleChange}">{{$t('DBTNF')}}</span>
            <img v-show="lab17" src="../assets/cancel_red.png">
          </div>
          <div class="filter-label" @click="choose2" :class="{'choose1':lab2,'de6':isDe||isIt,'po4':isPo,'fr2':isFr}">
            <span :class="{'ZH3':styleChange}">{{$t('Female')}}</span>
            <img v-show="lab2" src="../assets/cancel_red.png">
          </div>
          <div class="filter-label" @click="choose3" :class="{'choose1':lab3,'es3':isEs,'de6':isDe||isIt,'po4':isPo,'pl4':isPl}">
            <span :class="{'ZH3':styleChange}">{{$t('Male')}}</span>
            <img v-show="lab3" src="../assets/cancel_red.png">
          </div>
        </div>

        <hr class="patientList-small-hr">
        <div class="lab-group2">
          <label>{{$t('Age')}}</label>
          <div class="patientList-line">
            <div class="label1" @click="choose5" :class="{'choose':lab5,'ZH1':styleChange,'es2':isEs||isIt||isFr,'de5':isDe,'po2':isPo,'du2':isDu, 'pl2':isPl}">
              <span :class="{'ZH':styleChange||isCz}">{{$t('All')}}</span>
              <img v-show="lab5" src="../assets/cancel_red.png">
            </div>
          </div>
          <div class="filter-label long-lab" :class="{'choose2':lab18,'es1':isEs,'de1':isDe,'po3':isPo,'du3':isDu,'fr1':isFr,'sw1':isSw, 'pl3':isPl}"  @click="choose18()">
            <span :class="{'ZH3':styleChange}">{{$t('DBTNF')}}</span>
            <img v-show="lab18" src="../assets/cancel_red.png">
          </div>
          <div class="filter-label" @click="choose6" :class="{'choose1':lab6}"><span> < 18</span><img v-show="lab6" src="../assets/cancel_red.png"></div>
          <div class="filter-label" @click="choose7" :class="{'choose1':lab7}"><span>18-40</span><img v-show="lab7" src="../assets/cancel_red.png"></div>
          <div class="filter-label" @click="choose8" :class="{'choose1':lab8,'ZH8':styleChange}"><span>41-60</span><img v-show="lab8" src="../assets/cancel_red.png"></div>
          <div class="filter-label small_lab" @click="choose9" :class="{'choose1':lab9,'ZH9':styleChange}"><span>> 60</span><img v-show="lab9" src="../assets/cancel_red.png"></div>
        </div>

        <hr class="patientList-small-hr">
        <div class="lab-group3">
          <label>{{$t('Type')}}</label>
          <div class="patientList-line">
            <div class="label1" @click="choose10" :class="{'choose':lab10, 'ZH1':styleChange,'es2':isEs||isIt||isFr,'de5':isDe,'po2':isPo,'du2':isDu, 'pl2':isPl}">
              <span :class="{'ZH':styleChange||isCz}">{{$t('All')}}</span>
              <img v-show="lab10" src="../assets/cancel_red.png">
            </div>
          </div>
          <div class="patientList-type">
            <div class="filter-label long-lab" @click="choose19" :class="{'choose3':lab19, 'ZH5':styleChange,'es1':isEs,'de1':isDe,'po3':isPo,'du3':isDu,'fr1':isFr,'sw1':isSw,'cz1':isCz, 'pl3':isPl}">
              <span :class="{'ZH3':styleChange}">{{$t('DBTNF')}}</span><img v-show="lab19" src="../assets/cancel_red.png">
            </div>
            <div class="filter-label" @click="choose11" :class="{'choose1':lab11,'cz2':isCz}"><span>{{$t('Type 1')}}</span><img v-show="lab11" src="../assets/cancel_red.png"></div>
            <div class="filter-label" @click="choose12" :class="{'choose1':lab12,'cz2':isCz}"><span>{{$t('Type 2')}}</span><img v-show="lab12" src="../assets/cancel_red.png"></div>
            <div class="filter-label long-lab1" @click="choose15" :class="{'choose3':lab15, 'ZH2':styleChange}"><span>{{$t('LADA')}}</span><img v-show="lab15" src="../assets/cancel_red.png"></div>
            <div class="filter-label long-lab" @click="choose13" :class="{'choose2':lab13,'de2':isDe,'it6':isIt,'du4':isDu,'fr1':isFr,'ZH10':styleChange,'cz3':isCz}"><span>{{$t('Gestational')}}</span><img v-show="lab13" src="../assets/cancel_red.png"></div>
            <div class="filter-label long-lab" @click="choose14" :class="{'choose2':lab14,'po5':isPo, 'pl1':isPl}"><span>{{$t('Prediabetes')}}</span><img v-show="lab14" src="../assets/cancel_red.png"></div>
            <div class="filter-label small_lab" @click="choose16" :class="{'choose1':lab16}"><span>{{$t('OTR1')}}</span><img v-show="lab16" src="../assets/cancel_red.png"></div>
          </div>
        </div>

        <hr class="patientList-small-hr patientList-spe1-hr">
      </div>

      <div slot="footer" class="patientList-dialog-footer">
        <button  @click="checkFilter" >{{$t('Apply')}}</button>
      </div>
    </el-dialog>
    <!--Add对话框-->
    <!-- <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('addP')}}</span>
        <img src="../assets/cancel.png" @click="cancelAdd">
      </div>
      <div slot class="dialog-body">
        <div class="new">
          <img src="../assets/new patient.png">
          <button  @click="NewPatient">{{$t('newP')}}</button>
        </div>
        <div class="find">
          <img src="../assets/find patient.png">
          <button  @click="findPatient">{{$t('findP')}}</button>
        </div>
        <hr class="patientList-small-hr patientList-spe1-hr">
      </div> -->

      <!-- <div slot="footer" class="patientList-dialog-footer">
        <button  class="cancelButton" @click="cancelAdd">{{$t('Cancel')}}</button>
      </div>
    </el-dialog> -->

    <!--时间选择对话框-->
    <el-dialog  :visible.sync="showConfirmDialog" :size=dialogSize2  id="dialog-form3"
                :show-close="false" :close-on-click-modal="false">
      <div class="dialog-title">
        <p>{{$t('privacy_policy_and_terms_of_use')}}</p>
      </div>

      <div class="dialog-content">
        <p v-html="$t('privacy_confirm_text')"></p>
      </div>

      <div class="dialog-footer">
        <button @click="denyPrivacyConfirm" class="deny">{{$t('privacy_confirm_disagree')}}</button>
        <button @click="agreePrivacyConfirm" class="agree">{{$t('privacy_confirm_accept')}}</button>
        <div style="clear: both;"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import auth from '../auth/auth'
  import B64 from '../auth/base64'
  export default {
    name: 'home1',
    data () {
      return {
        keywords: '',
        searchPatient:false, activeIndex: '1', dialogFormVisible: false,
         tooltipVisible:true, styleChange:'',isEs:false,isZh:false,
        pages:'', page:1, has_next:'', has_prev:'',dialogSize:'tiny', dialogSize2:'small',isC:false,isSw:false,isCz:false,
        uids:[],flag:0,count:0,filter:'',filFlag:false,filFlag2:false,isDe:false,isIt:false,isPo:false,isPl:false,isDu:false,isFr:false,
        lab1:false, lab2:false,  lab3:false, lab5:false, lab6:false,  lab7:false, lab8:false,lab17:false,lab18:false,
        lab9:false, lab10:false,  lab11:false, lab12:false, lab13:false, lab14:false,  lab15:false, lab16:false,lab19:false,
        isEU:true,
        showConfirmDialog:false,
        hcpGroupMenu:false,
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
        currentPage:1,
        pageSize:11,
        totalPage:1,
        displayTab:true,
        imgSrc:require('../assets/portrait.png'),
        checked:false,
        checkList:[],
        autocomplate:'off'
      }
    },
    beforeCreate(){
      //如果没有token的话需要重新登录
      auth.checkAuth();
      if(!auth.authenticated){
        //this.$router.push('login');
        //console.log(sessionStorage.getItem('token'));
      }
      this.$store.state.users =[]
    },
    computed:{
      users(){
        return this.$store.state.users;
     },
     currentPageData(){
        let pa = Math.ceil(this.$store.state.users.length / this.pageSize)
        pa = pa ==0?1:pa
        this.totalPage = pa
        let begin = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        this.displayTab =false;
        return this.$store.state.users.slice(begin,end)
     }
    },
    methods: {
      getUsers() {
        this.displayTab =true
        this.filFlag2 = (this.keywords)?true:false;
        if(this.filFlag||this.keywords){
          let para ={
            filter:this.filter,
          };
          para= B64.base64encode(JSON.stringify(para));
        }else{
          let para = {
            page:this.page,
          };
          auth.getUserListAll(this,{per_page:9999});
        }
        // this.start();
      },
      //刷新勾选
      start(){
        const table  = document.getElementById('patientList');
        const labels = table.getElementsByTagName('label');
        for(let i=0;i<labels.length;i++){
            labels[i].className = ' ';
        }
      },
      imgload(e){
        let c ='/api/v2.0/person/'+e+'/portrait?t'
        return 'this.οnlοad=null;this.src='+'"'+ c +'";'
      },
      //全选
      chooseAll(){
        let _this = this
        if (!_this.checked) {
          _this.checkList = []
        } 
        else {
          _this.checkList = []
          _this.users.forEach(function(item,index) {
            if (index >= 0) {
              _this.checkList.push(item.uid)
            }
          })
        }
         console.log(_this.users)
      },
      // 重置头像
      reportrait(){
        for(let i=0;i<this.$refs.imgs.length;i++) {
          this.$refs.imgs[i].src =this.imgSrc
        }
      },
      //删除患者
      deleteP(){
         if(this.checkList.length>0){
           let tip = this.$t('deletePtip');
           let tip1 = this.$t('confirm');
           let tip2 = this.$t('Yes');
           let tip3 = this.$t('No');
           this.$confirm(tip, tip1, {
             confirmButtonText: tip2,
             cancelButtonText: tip3,
             type: 'warning'
           }).then(() => {
             let uids = this.checkList;
             this.$http.post('api/v2.0/patients/delete',{'uids':uids}).then(function (res) {
               let err =res.body.error;
               if(err === 0){
                 let tip = this.$t('deleteSuccess');
                 this.$message({
                   type: 'success',
                   message: tip,
                 });
                 this.reportrait()
                 this.getUsers();
               }
             },function(err){
               let tip = this.$t('deleteFailed');
               this.$message.error(tip);
             })
           },function () {

           });
         }
      },

      //跳转去患者信息页
      goDetail(e){
        let num =(this.currentPage-1)*11
        console.log('num:'+num)
        let parentNodeid =e.currentTarget.id
        let index = +parentNodeid + +num
        // console.log('parentNode:'+parentNodeid)
        // console.log('index:'+index)
        let uid = this.users[index].uid;
        let name = this.users[index].name;
        if(name === null||undefined){
          name = ''
        }
        console.log('uid'+uid+'，name'+name)
        sessionStorage.setItem('chart6page','')
        sessionStorage.setItem('patientId',uid);
        sessionStorage.setItem('patientName',name);
        let danum =this.currentPage
        sessionStorage.setItem('patientPages',danum);
       // this.$store.commit('updatePatientName',name);
        this.$router.push('/monitor');

      },
      //下一页
      nextPage(){
        if(this.currentPage ==this.totalPage) return
        this.reportrait()
        this.currentPage++
        this.start();
      },
      //上一页
      prevPage(){
        if(this.currentPage ==1) return
        this.reportrait()
        this.currentPage--
        this.start();
      },
      //输入页码跳转
      go(){
        if(0<this.currentPage&&this.currentPage<this.totalPage+1){
          this.reportrait()
          this.getUsers();
        }else{
          this.reportrait()
          this.currentPage = 1
          this.getUsers();
        }
      },

      NewPatient(){
        this.$router.push('/newPatient');
      },
      findPatient(){
        this.$router.push('/findPatient');
      },
      //筛选样式添加
      choose1(){
        this.lab1 = !this.lab1;
        this.lab2 = false;
        this.lab3 = false;
        this.lab17 = false;
      },
      choose2(){
        this.lab2 = !this.lab2;
        this.lab1 = false;
      },
      choose3(){
        this.lab3 = !this.lab3;
        this.lab1 = false;
      },
      choose17(){
        this.lab17 = !this.lab17;
        this.lab1 = false;
      },
      choose5(){
        this.lab5 = !this.lab5;
        this.lab6 = false;
        this.lab7 = false;
        this.lab8 = false;
        this.lab9 = false;
        this.lab18 = false;
      },
      choose6(){
        this.lab6 = !this.lab6;
        this.lab5 = false;
      },
      choose7(){
        this.lab7 = !this.lab7;
        this.lab5 = false;
      },
      choose8(){
        this.lab8 = !this.lab8;
        this.lab5 = false;
      },
      choose9(){
        this.lab9 = !this.lab9;
        this.lab5 = false;
      },
      choose18(){
        this.lab18 = !this.lab18;
        this.lab5 = false;
      },
      choose10(){
        this.lab10 = !this.lab10;
        this.lab11 = false;
        this.lab12 = false;
        this.lab13 = false;
        this.lab14 = false;
        this.lab15 = false;
        this.lab16 = false;
        this.lab19 = false;
      },
      choose11(){
        this.lab11 = !this.lab11;
        this.lab10 = false;
      },
      choose12(){
        this.lab12 = !this.lab12;
        this.lab10 = false;
      },
      choose13(){
        this.lab13 = !this.lab13;
        this.lab10 = false;
      },
      choose14(){
        this.lab14 = !this.lab14;
        this.lab10 = false;
      },
      choose15(){
        this.lab15 = !this.lab15;
        this.lab10 = false;
      },
      choose16(){
        this.lab16 = !this.lab16;
        this.lab10 = false;
      },
      choose19(){
        this.lab19 = !this.lab19;
        this.lab10 = false;
      },
      //筛选提示
      checkFilter(){
        this.dialogFormVisible = false;
        let flag = (this.lab2 || this.lab3 || this.lab6 || this.lab7 || this.lab8 || this.lab9 || this.lab11 || this.lab12
          || this.lab13 || this.lab14 || this.lab15|| this.lab16|| this.lab17|| this.lab18|| this.lab19);
        this.filFlag = flag;
        if (flag||this.keywords) {
          if (flag){ this.tooltipVisible = false;}
          let gender = [],age=[],diabetes_type=[],filter={};
          if(this.lab2){gender.push('GDRF')}
          if(this.lab3){gender.push('GDRM')}
          if(this.lab17){gender.push('GDRNF')}

          if(this.lab6){age.push([0,17])}
          if(this.lab7){age.push([18,40])}
          if(this.lab8){age.push([41,60])}
          if(this.lab9){age.push([61,200])}
          if(this.lab18){age.push(null)}

          if(this.lab11){diabetes_type.push('DBT1')}
          if(this.lab12){diabetes_type.push('DBT2')}
          if(this.lab13){diabetes_type.push('DBTGEST')}
          if(this.lab14){diabetes_type.push('DBTPRE')}
          if(this.lab15){diabetes_type.push('DBTLADA')}
          if(this.lab19){diabetes_type.push('DBTNF')}

          if(gender.length!==0&&gender.length!==3){
              filter.gender = gender;
          }
          if(age.length!==0&&age.length!==5){
              filter.age = age;
          }
          if(diabetes_type.length!==0&&diabetes_type.length!==6){
              filter.diabetes_type =diabetes_type;
          }

          filter.keywords = this.keywords;
          this.filFlag2 = (this.keywords)?true:false;
          this.filter = filter;
          let para ={
              filter:filter,
          };
          para= B64.base64encode(JSON.stringify(para));
          auth.getUserList(this,{'param':para, 'page':1});

        }
        else {
          this.tooltipVisible = true;
          this.getUsers();
        }
      },
      check(flag){
        if(flag===1){
          this.currentPage = 1
          this.checkFilter();
        }
        this.searchPatient = !this.searchPatient;
      },

      //取消筛选
      cancelFilter(){
        this.dialogFormVisible = false;
        this.checkFilter();
      },

      //时间格式化
      formateDate(date){
        let y = date.getFullYear();
        let m = date.getMonth();
        let d =date.getDate();
        let h = date.getHours();
        let mi = date.getMinutes();
        let s = date.getSeconds();
        m = m<10 ? ('0'+m ): m;
        d = d<10 ? ('0'+d) : d;
        return y+'-'+m+'-'+d+' '+h+':'+mi+':'+s;
      },
      checkPrivacyVersion() {
        this.$http.get('/api/v2.1/user/privacy/confirm').then(function(res){
          console.log("privacy confirm:", res.data);
          if (0==res.data.error) {
            if (0==res.data.confirm) {
              this.showConfirmDialog=true;
            }
          }
        }, function(err){

        })
      },
      denyPrivacyConfirm(){
        this.showConfirmDialog=false;
      },
      agreePrivacyConfirm(){
        this.showConfirmDialog=false;
        this.$http.post('/api/v2.1/user/privacy/confirm').then(function (res) {
          console.log('privacy confirm:', res.data)
        },function (err) {

        })
      },
      backToMenu(){
        this.$router.push('/HcpMenu')
      }
    },
    mounted:function () {
      let dnum =sessionStorage.getItem('patientPages');
      if(dnum == null|| dnum ==='null'||!dnum) {
        dnum =1
      }
      this.currentPage =dnum
      this.displayTab =true
      let para = {
        page: this.page,
      };
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      let lang  = sessionStorage.getItem('language');
      this.styleChange=(lang==='zh'||lang==='hk') ? true:false;
      this.isEs=(lang==='es') ? true:false;
      this.isDe=(lang==='de') ? true:false;
      this.isIt=(lang==='it') ? true:false;
      this.isPo=(lang==='po') ? true:false;
      this.isPl=(lang==='pl') ? true:false;
      this.isDu=(lang==='du') ? true:false;
      this.isFr=(lang==='fr') ? true:false;
      this.isSw=(lang==='sw') ? true:false;
      this.isZh = (lang==='zh')?true:false;
      this.isCz = (lang==='cz')?true:false;
      let userCreatedBy = localStorage.getItem('userCreatedBy');
      console.log('userCreatedBy:', userCreatedBy);
      this.hcpGroupMenu=(localStorage.getItem('userCreatedBy')!='hcp_group');
      let countryIndex=localStorage.getItem('index');
      console.info('countryIndex:'+countryIndex+','+lang+','+this.isPl);
      if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
        this.isEU=false;
      }
      auth.getUserListAll(this,{per_page:9999});
      this.checkPrivacyVersion();
      setTimeout(()=>{
        let host=auth.getOuterHost();
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)
    },
    watch: {
      currentPageData(){
        this.displayTab =false
      },
      checkList(){
        // console.log(this.checkList)
      },
      checked(){
         let _this = this
        if (!_this.checked) {
          _this.checkList = []
        } 
        else {
          _this.checkList = []
          _this.users.forEach(function(item,index) {
            if (index >= 0) {
              _this.checkList.push(item.uid)
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  #PainterList{
    width:100%;
    background-color: #fff;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  #container{
    min-height:874px;
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top:15px;
  }

  #list{
    margin:0 auto;
    width: 97%;
    min-height: 840px;
    background:#fff;
    box-shadow:0 3px 4px 0 rgba(175,175,175,0.50);
    border-radius:6px;
    border:none;
    position: relative;
  }
  .patientList-operate{
    height:30px;
    width:100%;
    margin-bottom: 20px;
  }
  .patientList-operate button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    border-radius:100px;
    width: 161px;
    height: 30px;
    border: none;
    outline: none;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#ffffff;
    margin-right: 15px;
  }
  .patientList-operate button:hover{
    cursor: pointer;
  }
  .patientList-operate  .cancel{
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
  }
  #danger{
    background-image:linear-gradient(89deg, #ff3535 1%, #ff5252 100%);
    width:100px;
  }
  #filter{
    width:100px;
  }
  .patientList-search{
    float: right;
    background:#ffffff;
    box-shadow:0 9px 26px 0 rgba(97,132,166,0.05);
    width:158px;
    height:28px;
    outline: none;
    border-radius: 100px;
    border: 1px solid #cccccc;
  }
  .patientList-search input{
    width:120px;
    height:24px;
    outline:none;
    border: none;
    display: block;
    margin-left:13px;
    margin-top:2px;
    float: left;
  }
  .patientList-search input:focus{
    color:#2aace0;
  }
  .patientList-search img{
    height:16px;
    width:16px;
    float: left;
    margin-top: 5px;
  }
  .patientList-search img:hover{
    cursor: pointer;
  }
  .patientList-in{
    border:1px solid #009fdf;
    height:28px;
    width:156px;
  }
  .patientList-in1{
    margin-left:-2px;
  }

  /*表格*/
  .patient-table{
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color: #282828;
    letter-spacing:-0.44px;
    text-align:center;
  }
  table{
    width:100%;
    border-collapse: collapse;
  }
  .patient-table .header{
    color:#005dac;
    height:70px;
    background:#cfdff0;
    font-size:18px;
  }
  .patient-table .name{
    color:#005dac;
    width:16%;
    cursor: pointer;
    text-align: left;
    font-family:SFUIText-Regular;
    font-size:16px;
    letter-spacing:-0.39px;
    min-width: 140px;
  }
  .portrait{
    border-radius:100px;
    width:36px;
    height:36px;
    float: left;
    margin-left: 10%;
    margin-right: 10%;
  }
  .name p{
    margin-top: 10px;
  }
  .patient-table .gender{
    width:10%;
  }
  .patient-table .small{
    width:10%;
  }
  .patient-table .diabetes-date{
    width:15%;
  }
  tr{
    height: 60px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }
  .checkbox{
    width:7%;
  }
  .even{
    background:#ebeef1;
  }
  table input{
    width:16px;
    height:16px;
  }
  /* .checkbox22{
    opacity: 0;
  } */
  table label{
    display: inline-block;
    width:17px;
    height:17px;
    background: url("../assets/checkbox.png") left 1px no-repeat;
    cursor: pointer;
  }
  .checked{
    background: url("../assets/Select.png") left 0 no-repeat;
  }
  .name .filterResult{
   color: #e00;
  }

 /*分页*/
  .patientList-block{
    margin-top:15px;
    height:20px;
    width: 208px;
    letter-spacing:-0.44px;
    position: absolute;
    bottom: 15px;
  }
  .patientList-block img{
    cursor: pointer;
    float: left;
  }
  .patientList-block span{
    float: left;
    display: block;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    text-align:left;
    margin: -2px 20px 0;
  }
  .patientList-block input{
    font-family:SFUIText-Regular;
    font-size:18px;
    height:18px;
    width:36px;
    margin-right: 20px;
    text-align: center;
  }
  .patientList-block .click1{
    opacity: 0.3;
    cursor:auto;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }


  /*dialog对话框*/
  #dialog-form{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .lab-group1,.lab-group2,.lab-group3{
    width: 100%;
    height:45px;
    margin-left:17px;
  }
  .lab-group2{
    width: 86%;
  }
  .patientList-small-hr{
    background:#dedede;
    width:90%;
    height:1px;
    margin:10px 0 10px 20px;
    border:none;
    clear: both;
  }
  /*最后一栏标签数太多，水平线间距设置大点*/
  .patientList-spe1-hr{
    margin-top:40px;
  }
  #dialog-form label{
    display: block;
    float: left;
    width:65px;
    height:24px;
    margin-right:8px;
    margin-left: 5px;
    margin-top:10px;
    line-height: 24px;
    font-size: 16px;
    text-align: left;
    border-right:1px solid #ccc;
    color:#282828;
    letter-spacing:-0.39px;
  }
  #dialog-form .de3{
    margin-left: -9px;
    width: 80px;
  }
  .patientList-line{
    float:left;
    margin-top:10px;
    padding-bottom:1px;
    border-right:1px solid #ccc ;
  }
  .label1{
    float:left;
    width:50px;
    height:24px;
    line-height:24px;
    font-size: 14px;
    color:#282828;
    letter-spacing:-0.34px;
    cursor: pointer;
    margin-right: 10px;
  }
  .ZH1{
    margin-right: 5px;
  }
  .filter-label{
    float:left;
    width:70px;
    height:24px;
    line-height:24px;
    font-size: 14px;
    margin-top:10px;
    margin-left: 5px;
    color:#282828;
    letter-spacing:-0.34px;
    cursor: pointer;
  }
  .long-lab{
    width:96px;
  }
  .long-lab1{
    width:116px;
    margin-right: 10px;
  }
  .small_lab{
    margin-bottom: 10px;
  }
  .filter-label span{
    display: block;
    float: left;
    margin-left: 10px;
  }
  .ZH3{
    padding-left: 10px;
  }
  .ZH4{
    width:60px;
  }
  .label1 span{
    display: block;
    float: left;
    margin-left: 15px;
  }
  .label1 .ZH{
    margin-left:6px;
  }
  .filter-label img,.label1 img{
    float:right;
    margin:8px 4px 0 0;
  }
  .patientList-type{
    float: left;
    width:60%;
  }
  .choose{
    height:22px;
    width:48px;
    border:1px solid #979797;
    border-radius:4px;
  }
  .choose1{
    height:22px;
    width:68px;
    border:1px solid #979797;
    border-radius:4px;
  }
  .choose2{
    height:22px;
    width:94px;
    border:1px solid #979797;
    border-radius:4px;
  }
  .choose3{
    height:22px;
    width:114px;
    border:1px solid #979797;
    border-radius:4px;
  }
  .choose4{
    height:22px;
    width:150px;
    border:1px solid #979797;
    border-radius:4px;
  }
  .de17{
    width:190px;
  }
  .de18{
    width:200px;
  }
  .it18{
    width:185px;
  }
  .es18{
    width:215px;
  }
  .po17{
    width:180px;
  }
  .po19{
    width:180px;
  }
  .po18{
    width:225px;
  }


  .es1{
    width:118px;
  }
  .es2{
    width:60px;
  }
  .es3{
    width:80px;
  }
  .de1{
    width:128px;
  }
  .de2{
    width:182px;
  }
  .it6{
    width: 105px;
  }
  .de4{
    width:65px;
  }
  .de5{
    width:55px;
  }
  .de6{
    width:85px;
  }
  .po2{
    width:70px;
  }
  .po3{
    width:125px;
  }
  .po4{
    width:85px;
  }
  .po5{
    width:115px;
  }
  .pl1{
    width:155px;
  }
  .pl2{
    width:70px;
  }
  .pl3{
    width:112px;
  }
  .pl4{
    width:90px;
  }
  .ZH2{
    width:180px;
    margin-left:0;
  }
  .ZH2 span{
    padding-left: 0;
  }
  .ZH10 {
    margin-left:-8px;
  }
  .ZH5{
    width:94px;
  }
  .ZH8{
    width: 80px;
    padding-left: 13px;
  }
  .du2{
    width:55px;
  }
  .du3{
    width:130px;
  }
  .du4{
    width:125px;
  }

  .fr1{
    width: 100px;
  }
  .fr2{
    width: 80px;
  }
  .sw1{
    width: 90px;
  }
  .sw2{
    width: 190px;
  }
  .cz1{
    width: 95px;
  }
  .cz2{
    width: 120px;
  }
  .cz3{
    width: 160px;
  }
  .patientList-dialog-footer{
    width:65%;
    margin-top:-30px;
  }
  .patientList-dialog-footer button,#dialog-form2 button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:150px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  #dialog-form2 .cancelButton{
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    margin-bottom: 20px;
    margin-top: 10px;
  }
  #dialog-form2 .dialog-body{
    font-family:SFUIText-Regular;
    font-size:15px;
    color:#ffffff;
    letter-spacing:-0.36px;
    text-align:center;
  }
  .new,.find{
    float: left;
    width:150px;
    margin-bottom: 34px;
    margin-top: 35px;
    margin-left: 10%;
  }
  .find{
    float: right;
    margin-right: 10%;
    margin-left: 0;
  }
  .new img,.find img{
    height:60px;
    width:60px;
    display: block;
    margin-left: 45px;
    margin-bottom: 30px;
  }

  /*筛选提示框*/
  .patientList-label-tooltip{
    width:300px;
    height:135px;
    background:rgba(255,255,255,0.97);
    *box-shadow:0 2px 4px 0 rgba(30,30,30,0.50);
    border-radius:5px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .patientList-title{
    margin:15px 0 10px 10px;
    border-left: 2px solid #005dac;
  }
  .patientList-title span{
    margin-left:13px;
  }
  .patientList-small2-hr{
    background:#e6e8ea;
    width:260px;
    height:1px;
    margin:0 auto;
    border:none;
  }
  .label-group{
    width:246px;
    margin: 0 auto;
  }
  .label-group .filter-label{
    margin-right: 6px;
  }

  .el-table-column{
    border:none;
    color:#005dac;
  }
  .dialog-title {
    margin-bottom: 30px;
    font-size:18px;
    font-weight: bold;
  }

  .dialog-footer{
    margin:35px auto 0px;
    width:90%;
  }
  .dialog-footer button{
    *background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:3px;
    width:20%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }

  .dialog-footer .deny {
    float:left;
    background-color:#888;
  }

  .dialog-footer .agree {
    float:right;
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }
  .back-btn {
    display:inline-block;
  }
  @media screen and (max-width: 1500px){
    #container{
      width:92%;
    }
    .ZH9{
      width: 80px;
      padding-left: 13px;
    }
  }
  @media screen and (min-height: 950px){
    #container{
      min-height:904px;
    }
  }
</style>



// WEBPACK FOOTER //
// PatientList.vue?6d5bf51a